<template>
  <div>
    <!-- Thumbnail image always set to first -->
    <div
      class="thumbnail-container"
      @click="lightboxEffect(0)"
    >
      <span>
        <span
          v-if="showPlay && thumbnail"
          class="material-icons playArrow"
        >play_arrow</span>
        <img
          v-if="thumbnail"
          :src="thumbnail"
          class="lightbox-thumbnail"
          :class="{ 'default-lightbox-thumbnail': isDefaultImg }"
        >
      </span>
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="gallery"
        class="lightbox-bg"
        @click.stop="close"
      />
    </transition>

    <!-- Gallery -->
    <div v-if="gallery">
      <div
        v-if="gallery"
        class="lightbox-container"
      >
        <div class="lightbox-close lightbox-title">
          {{ images[currentImage].title }}
        </div>
        <div
          class="lightbox-close"
          @click.stop="close"
        >
          X
        </div>
        <div
          v-if="images.length > 1"
          class="lightbox-prev lightbox-btn"
          @click="prev"
        >
          &#10094;
        </div>

        <transition
          name="fade"
          mode="out-in"
        >
          <!-- Check if media is image or video -->
          <div
            v-if="imageOrVideo === 'm3u8' || imageOrVideo === 'mp4'"
            class="video-container"
          >
            <video-stream
              :options="{
                ...videoOptions,
                sources: { src: images[currentImage].src },
              }"
              class="video-container"
            />
          </div>
          <div
            v-else-if="isYouTubeVideo"
            class="video-container-youtube"
          >
            <youtube
              class="lightbox-spot"
              :video-id="videoId"
              :fit-parent="true"
              :resize="true"
            />
          </div>
          <div v-else>
            <img
              v-if="images[currentImage].src"
              :src="`${images[currentImage].src}?width=900&quality=50`"
              class="lightbox-container-image"
            >
            <img
              v-else
              :src="`${images[currentImage]}?width=900&quality=50`"
              class="lightbox-container-image"
            >
          </div>
        </transition>

        <!-- Current image marker -->
        <div
          v-if="count"
          class="lightbox-count"
        >
          <span
            v-for="(item, index) in images"
            :key="index"
            :class="{ spot: currentImage === index }"
            class="lightbox-spot"
          />
        </div>
        <div
          v-if="images.length > 1"
          class="lightbox-next lightbox-btn"
          @click="next"
        >
          &#10095;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Youtube, getIdFromUrl } from "vue-youtube";
import VideoStream from "../../modules/video-modal/video.vue";
export default {
  components: {
    Youtube,
    VideoStream,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    thumbnail: {
      type: String,
      required: false,
      default: "",
    },
    isDefaultImg: {
      type: Boolean,
    },
    showPlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      gallery: false,
      currentImage: 0,
      count: true,
      videoId: "",
      videoOptions: {
        autoplay: false,
        controls: true,
        poster: "",
        sources: [
          {
            src: "",
            type: "application/x-mpegURL",
          },
        ],
      },
    };
  },
  computed: {
    imageOrVideo() {
      if (this.images[0].src) {
        return this.images[this.currentImage].src.split(".").pop();
      } else {
        return this.images[this.currentImage].split(".").pop();
      }
    },
    isYouTubeVideo() {
      let isYoutube;
      this.videoId ? (isYoutube = true) : (isYoutube = false);
      return isYoutube;
    },
  },
  watch: {
    show: function (newVal, oldVal) {
      this.gallery = newVal;
    },
  },
  mounted() {
    if (this.enableAutoplay) {
      this.videoOptions.autoplay = true
    }
    if (this.images[0].src) {
      this.videoId = getIdFromUrl(this.images[0].src);
    }
  },
  methods: {
    lightboxEffect(curr) {
      this.currentImage = curr;
      this.gallery = !this.gallery;
    },
    next() {
      if (this.currentImage < this.images.length - 1) {
        this.currentImage++;
      } else {
        this.currentImage = 0;
      }
    },
    prev() {
      if (this.currentImage > 0) {
        this.currentImage--;
      } else {
        this.currentImage = this.images.length - 1;
      }
    },
    close() {
      this.$emit("closeEvent", "close");
      this.gallery = false;
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
